export default __webpack_public_path__ + "static/media/error-request.2a6cd861.svg";